import React, { useState } from 'react';

import { useAuth } from '~/hooks/auth';
import Dashboard from '~/pages/Data/Dashboard';
import Reports from '~/pages/Data/Reports';
import { permissions } from '~/types/constants';

import { Container, TabPanel, Tab, TabButton } from './styles';

type Tab = 'Dashboard' | 'Reports' | null;

const Data: React.FC = (): JSX.Element => {
  const { checkPermission } = useAuth();

  const [tab, setTab] = useState<Tab>(() => {
    if (checkPermission([permissions.VIEW_DASHBOARD])) {
      return 'Dashboard';
    }
    if (checkPermission([permissions.VIEW_REPORTS])) {
      return 'Reports';
    }
    return null;
  });

  const handleRenderContent = () => {
    if (tab) {
      return tab === 'Dashboard' ? <Dashboard /> : <Reports />;
    }
    return null;
  };

  return (
    <Container>
      <TabPanel>
        {checkPermission([permissions.VIEW_DASHBOARD]) && (
          <TabButton type="button" onClick={() => setTab('Dashboard')}>
            <Tab active={tab === 'Dashboard'}>Dashboard</Tab>
          </TabButton>
        )}
        {checkPermission([permissions.VIEW_REPORTS]) && (
          <TabButton type="button" onClick={() => setTab('Reports')}>
            <Tab active={tab === 'Reports'}>Relatórios</Tab>
          </TabButton>
        )}
      </TabPanel>
      {handleRenderContent()}
    </Container>
  );
};

export default Data;
